<template>
<div class="d-page-card">
    <slot></slot>
</div>
</template>
